export enum LocalStorageKey {
  AuthInfo = "AUTH_INFO",
  PendingRedirectPath = "PENDING_REDIRECT_PATH",
  UpgradedUserEmail = "UPGRADED_USER_EMAIL",
}
